import React, { useState } from "react";
import "./DeleteAccountModal.css";
import { FaTrashAlt, FaShieldAlt } from "react-icons/fa";
import { useSalon } from "../../context/SalonContext";
import SalonService from "../../services/SalonService";
import userService from "../../services/user.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DeleteAccountModal = ({ show, onClose }) => {
    const { customerId, mobileNumber, logout } = useSalon();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");

    if (!show) return null;

    const handleSendOtp = async () => {
        setLoading(true);
        setErrorMessage("");
        try {
            let formattedMobile = mobileNumber || localStorage.getItem("MOBILE_NUMBER") || "";
            if (formattedMobile && !formattedMobile.startsWith("+")) {
                formattedMobile = "+91" + formattedMobile.replace(/\D/g, "").slice(-10);
            }
            const res = await SalonService.sendLoginOTP({ mobileNumber: formattedMobile });
            if (res.status === 200) {
                setOtpSent(true);
                toast.info("OTP sent to your registered mobile number");
            }
        } catch (err) {
            console.error("Error sending OTP for account deletion:", err);
            setErrorMessage(err.response?.data?.message || err.response?.data || "Failed to send OTP. You can still confirm deletion below.");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteAccount = async () => {
        setLoading(true);
        setErrorMessage("");

        const currentCustomerId = customerId || localStorage.getItem("CUSTOMER_ID");
        const currentMobile = mobileNumber || localStorage.getItem("MOBILE_NUMBER");

        const data = {
            customerId: currentCustomerId,
            mobileNumber: currentMobile,
            otp: otp || undefined
        };

        try {
            try {
                await SalonService.deleteCustomerAccount(data);
            } catch (err1) {
                await userService.deleteCustomerAccount(data);
            }

            toast.success("Your account has been deleted successfully");
            logout();
            onClose();
            navigate("/login");
        } catch (err) {
            console.error("Failed to delete account:", err);
            const errorText = err.response?.data?.message || err.response?.data || "Failed to delete account. Please try again.";
            setErrorMessage(typeof errorText === "string" ? errorText : "Failed to delete account");
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setOtpSent(false);
        setOtp("");
        setErrorMessage("");
        onClose();
    };

    return (
        <div className="premium-modal-overlay">
            <div className="premium-delete-card">
                <div className="delete-icon-wrapper">
                    <FaTrashAlt className="delete-icon" />
                </div>

                <h3 className="premium-modal-title">Delete Account</h3>
                <p className="premium-modal-message">
                    Are you sure you want to delete your account? This action is permanent. All your booking history, profile details, and rewards will be permanently deleted.
                </p>

                {otpSent && (
                    <div className="delete-otp-section">
                        <div className="otp-input-wrapper">
                            <input
                                type="text"
                                className="delete-otp-input"
                                placeholder="Enter 6-Digit OTP"
                                maxLength="6"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                        </div>
                    </div>
                )}

                {errorMessage && <p className="delete-error-msg">{errorMessage}</p>}

                <div className="premium-modal-actions">
                    {!otpSent ? (
                        <>
                            <button
                                className="premium-btn-danger"
                                onClick={handleSendOtp}
                                disabled={loading}
                            >
                                <FaShieldAlt className="me-2" /> {loading ? "Sending OTP..." : "Verify with OTP to Delete"}
                            </button>
                            <button
                                className="premium-btn-danger-secondary"
                                onClick={handleDeleteAccount}
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Confirm Delete Without OTP"}
                            </button>
                        </>
                    ) : (
                        <button
                            className="premium-btn-danger"
                            onClick={handleDeleteAccount}
                            disabled={loading || otp.length !== 6}
                        >
                            {loading ? "Deleting Account..." : "Confirm & Delete Account"}
                        </button>
                    )}

                    <button className="premium-btn-secondary" onClick={handleModalClose} disabled={loading}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountModal;
